import React from 'react';
import assign from 'object-assign';

import { Card, CardText } from 'material-ui/Card';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import DatePicker from '../Common/DatePicker';
import FlatButton from 'material-ui/FlatButton';
import Form from '../Common/Form.react';
import MenuItem from 'material-ui/MenuItem';
import MultiCheckboxSet from '../Common/MultiCheckboxSet';
import SelectField from '../Common/SelectField';
import TextField from '../Common/TextField';

import UserActions from '../../actions/UserActionCreator';
import UserStore from '../../stores/UserStore';
import OrganisationStore from '../../stores/OrganisationStore';
import OrganisationActions from '../../actions/OrganisationActionCreator';
import AttributeStore from '../../stores/AttributeStore';
import UsernameStore from '../../stores/UsernameStore';
import AuthMethodStore from '../../stores/AuthMethodStore';
import { formatName } from '../../utils/StringUtils';

const url = '/dashboard/users';
const style = {
    checkbox: {
        margin: '16px'
    }
};

const UserForm = React.createClass({

    getInitialState: function () {
        return {
            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),
            titles: [
                'Mr',
                'Mrs',
                'Ms',
                'Miss',
                'Dr',
                'Prof'
            ],
            organisations: OrganisationStore.getAll(),
            roles: UserStore.getRoles(),
            details: {
                id: '',
                title: '',
                firstName: '',
                lastName: '',
                initials: '',
                email: '',
                username: '',
                dateOfBirth: null,
                organisation: '',
                organisationId: '',
                jobRole: '',
                enabled: true,
                roles: null, // specifically differs from empty array
                attributes: [],
                extId: '',
                archived: false,
                authMethod: null
            },
            allAttributes: AttributeStore.getAll(),
            firstName: '',
            lastName: '',
            username: '',
            suggestedUsername: '',
            errors: {},
            authMethods: []
        }
    },

    componentDidMount: function() {
        this.listeners = [
            OrganisationStore.addListener(this._onOrganisationsReceived),
            AttributeStore.addListener(this._onAttributeChange),
            UsernameStore.addListener(this.onUsernameValidation),
            AuthMethodStore.addListener(this.onAuthMethodsChange)
        ];
        if (this.state.isEdit) {
           this.listeners.push( UserStore.addListener(this._onChange) );
           UserActions.getById(this.props.routeParams.id);
        }
        OrganisationActions.getAll();
        UserActions.getActiveAttributes();
        UserActions.listAuthMethods();
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
    },

    render: function() {
        let enabled = (!!this.state.details.enabled);

        const formTitle  = (this.props.routeParams.id === undefined ? 'New' : formatName(this.state.details));
        const redirectTo = (this.state.isEdit ? `/dashboard/user/${this.state.details.id}/settings` : url);

        const dateFieldProps = {
            name: 'dateOfBirth',
            hintText: "Date of birth",
            floatingLabelText: "Date of birth",
            value: this.state.details.dateOfBirth
        };

        let attributeFields = [];
        if (this.state.allAttributes !== undefined) {
            attributeFields = this.state.allAttributes.map(({code, name, typeName, isRequired, values}) => {
                switch (typeName) {
                    case 'text':
                        return (
                            <TextField
                                key={code}
                                name={code}
                                value={this._getAttributeValue(name)}
                                hintText={name}
                                floatingLabelText={name}
                                required={isRequired}
                            />
                        );
                    case 'option':
                        return(
                            <SelectField
                                key={code}
                                name={code}
                                value={this._getAttributeValue(name)}
                                hintText={name}
                                floatingLabelText={name}
                                required={isRequired}
                                autoWidth={true}
                            >
                                <MenuItem key="root" value={0} primaryText="(None)" />
                                {values && values.map((v) => <MenuItem key={v} value={v} primaryText={v} />)}
                            </SelectField>
                        );
                    default:
                        return null;
                }
            });
        }

        return (
            <Form
                title={formTitle}
                onSave={this._onSave}
                redirectTo={redirectTo}
                validationErrors={this.state.errors}
            >
                <Card className="cent-card">
                    <CardText>
                        <SelectField
                            name="title"
                            hintText="Title"
                            floatingLabelText="Title"
                            autoWidth={true}
                            value={this.state.details.title}
                        >
                            {this.state.titles.map((title, i) => <MenuItem key={i} value={title} primaryText={title} />)}
                        </SelectField>
                        <div className='cent-flex-row'>
                            <div className='cent-col-2'>
                                <TextField
                                    name="firstName"
                                    value={this.state.details.firstName}
                                    validations="minLength:2,maxLength:80"
                                    validationError="Please use only letters, at least 2"
                                    hintText="First name"
                                    floatingLabelText="First name"
                                    onChange={(e, value) => this.generateUsername('firstName', value)}
                                    required
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="lastName"
                                    value={this.state.details.lastName}
                                    validations="minLength:2,maxLength:80"
                                    validationError="Please use only letters, at least 2"
                                    hintText="Last name"
                                    floatingLabelText="Last name"
                                    onChange={(e, value) => this.generateUsername('lastName', value)}
                                    required
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="initials"
                                    value={this.state.details.initials}
                                    validations="minLength:1,maxLength:5"
                                    validationError="Please use only letters, at least 1"
                                    hintText="Initials"
                                    floatingLabelText="Initials"
                                />
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="email"
                                    value={this.state.details.email}
                                    validations="isEmail,maxLength:120"
                                    validationError="Please enter a valid email address"
                                    hintText="Email"
                                    floatingLabelText="Email"
                                    required
                                />
                            </div>
                        </div>
                        {!this.state.isEdit && (
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <TextField
                                        name="username"
                                        value={this.state.username}
                                        validations={{minLength: 7, maxLength: 120, matchRegexp: /^[a-z0-9\-_.]+$/i}}
                                        validationError="Please enter a valid username, at least 7 characters long, without spaces"
                                        hintText="Username"
                                        floatingLabelText="Username"
                                        onChange={(e, value) => this.validateUsername(value)}
                                        required
                                        style={{width:'80%'}}
                                    />
                                    <FlatButton
                                        label="change"
                                        disabled={!this.state.errors.username || !this.state.suggestedUsername}
                                        style={{float: 'right', marginTop: 40}}
                                        onTouchTap={() => this.setState({username: this.state.suggestedUsername, errors: {}})}
                                    />
                                </div>
                            </div>
                        )}
                        <DatePicker {...dateFieldProps} />
                        <div className='cent-flex-row'>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="organisationId"
                                    hintText="Organisation"
                                    floatingLabelText="Organisation"
                                    value={this.state.details.organisationId}
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.organisations.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />)}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <TextField
                                    name="jobRole"
                                    value={this.state.details.jobRole}
                                    validations="maxLength:120"
                                    validationError="Please use only letters"
                                    hintText="Job role"
                                    floatingLabelText="Job role"
                                />
                            </div>
                        </div>
                        <TextField
                            key="extId"
                            name="extId"
                            value={this.state.details.extId}
                            hintText="extId"
                            floatingLabelText="extId"
                        />
                        <DatePicker
                            name="validFrom"
                            hintText="Valid from"
                            floatingLabelText="Valid from"
                            value={this.state.details.validFrom}
                        />
                        <SelectField
                            name="authMethod"
                            hintText="Auth method"
                            floatingLabelText="Auth method"
                            autoWidth
                            value={this.state.details.authMethod}
                        >
                            {this.state.authMethods.map(({ name }, i) => <MenuItem key={i} value={name} primaryText={name} />)}
                        </SelectField>
                        {attributeFields}
                        {this.state.roles.length > 0 && (
                            <MultiCheckboxSet
                                name="roles"
                                items={this.state.roles}
                                value={this.state.details.roles || []}
                                title="Roles"
                                required
                            />
                        )}
                        {!!this.state.isEdit && (
                            <Checkbox
                                name="archived"
                                value={this.state.details.archived}
                                label="Archived"
                                style={style.checkbox}
                            />
                        )}
                        <Checkbox
                            name="enabled"
                            value={enabled}
                            label="Enabled"
                            style={style.checkbox}
                        />
                    </CardText>
                </Card>
            </Form>
        );
    },

    _onSave: function(data) {
        data.attributes = [];
        let codes = [];
        this.state.allAttributes.forEach(({code}) => {
            if (!!data[code]) {
                data.attributes.push({code, value: data[code]});
                codes.push(code);
            }
        });

        if (this.state.isEdit) {
            this.state.details.attributes
                .filter(({code}) => !codes.includes(code))
                .forEach(({code}) => data.attributes.push({code, value: null}));

            return UserActions.update(this.props.routeParams.id, data);
        } else {
            return UserActions.save(data);
        }
    },

    _onChange: function() {
        const details = UserStore.getById(this.props.routeParams.id);
        if (!!details) {
            details.dateOfBirth = details.dateOfBirth ? new Date(details.dateOfBirth) : null;
            details.title = details.title || '';
            this.setState( {details} );
        }
    },

    _onOrganisationsReceived: function() {
        let organisations = OrganisationStore.getAll();
        if (organisations !== undefined) {
            const state = assign({}, this.state, {organisations});
            if (!state.isEdit && organisations.length === 1) {
                state.details.organisation = organisations[0].id;
            }
            this.setState(state);
        }
    },

    _onAttributeChange: function() {
        const allAttributes = AttributeStore.getAll();
        if (allAttributes !== undefined) {
            this.setState({allAttributes});
        }
    },

    _getAttributeValue: function(name) {
        let value = '';
        if (this.state.details.attributes !== undefined) {
            const attribute = this.state.details.attributes.find((a) => a !== undefined && a.name === name);
            if (!!attribute) {
                value = attribute.value;
            }
        }
        return value;
    },

    onAuthMethodsChange: function () {
        const authMethods = AuthMethodStore.getAll();
        if (!!authMethods) {
            this.setState({authMethods});
        }
    },

    generateUsername: function (field, value) {
        const firstName = field === 'firstName' ? value : this.state.firstName;
        const lastName = field === 'lastName' ? value : this.state.lastName;
        const username = `${firstName}${lastName}`.replace(/\s/g, '');
        this.setState({[field]: value});

        this.validateUsername(username, firstName, lastName);
    },

    validateUsername: function (username, firstName, lastName) {
        this.setState({username, errors: {}});
        if (username.length > 7) {
            this.timeout && clearTimeout(this.timeout);
            this.timeout = setTimeout(() => UserActions.validateUsername(username, firstName || this.state.firstName, lastName || this.state.lastName), 500);
        }
    },

    onUsernameValidation: function () {
        if (UsernameStore.isFetching()) { return; }

        const result = UsernameStore.getByUsername(this.state.username);
        if (!!result && !result.valid) {
            this.setState({
                errors: { username: `Username ${this.state.username} is already in use`},
                suggestedUsername: result.suggested || null
            });
        }
    }
});

export default UserForm;
